class BundleContainer extends HTMLElement {
  constructor() {
    super();
    this.cartProductArray = [];
    this.productLimit = 10;
    this.flickityInstance = null; 
  }

  connectedCallback() {
    this.bundleItem();
    this.finalBundleAddToCart();
    this.bindRemoveEvents();

    // Initialize slider on load and on resize
    this.checkAndInitSlider();
    window.addEventListener("resize", () => this.checkAndInitSlider());
  }

  checkAndInitSlider() {
    const sliderEl = this.querySelector(".bundle-slider-mobile");
    if (!sliderEl) return;

    const isMobile = window.innerWidth <= 1100;

    // Remove hidden class so Flickity can measure
    sliderEl.classList.remove("hidden");

    if (isMobile && !this.flickityInstance) {
      this.flickityInstance = new Flickity(sliderEl, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        pageDots: false,
        draggable: true,
        prevNextButtons: true,
      });
    } else if (!isMobile && this.flickityInstance) {
      // Optional: destroy Flickity on desktop
      this.flickityInstance.destroy();
      this.flickityInstance = null;
      sliderEl.classList.add("hidden"); // hide on desktop
    }
  }

  /** hook up add-to-cart buttons inside bundle-item-list */
  bundleItem() {
    const bundleItemList = this.querySelectorAll("bundle-item-list");
    bundleItemList.forEach((item) => {
      const addToCartButton = item.querySelector("add-to-cart");
      if (addToCartButton) {
        addToCartButton.addEventListener("click", () =>
          this.handleAddToCart(item)
        );
      }
    });
  }

  /** build a product object and push it into our array */
  handleAddToCart(item) {
    const wrapper = item;
    const selectedSwatch = wrapper.querySelector(".js-bundle-swatches.selected");
    const variantId = selectedSwatch ? selectedSwatch.dataset.variantId : wrapper.dataset.variantId;
    const variantName = selectedSwatch ? selectedSwatch.dataset.variantName : wrapper.dataset.variantName;
    const variantStyle = selectedSwatch ? selectedSwatch.getAttribute("style") : `${wrapper.dataset.variantStyle}`;

    if (!variantId) {
      console.warn("No variant id found for this item");
      return;
    }

    const imgEl = wrapper.querySelector(".js-media--wrapper .product-item__image--one img");
    const finalVariantImage = imgEl ? imgEl.src : null;
    const qty = 1;
    const uniqueKey = "Bundle_" + variantId + "_" + Math.floor(Math.random() * 1000000);

    this.addProductToArray({
      key: uniqueKey,
      variantId: variantId,
      variantName: variantName,
      variantStyle: variantStyle,
      image: finalVariantImage,
      quantity: qty,
    });

    setTimeout(() => {
      this.updateGiftMsg();
    }, 100);
  }

  /** push into array + render + auto scroll mobile slider */
  addProductToArray(productObj) {
    if (this.cartProductArray.length >= this.productLimit) {
      console.warn("Product limit reached, cannot add more");
      return;
    }

    this.cartProductArray.push(productObj);
    this.renderBundleCart();
    this.bindRemoveEvents();

    // Scroll to last added item if mobile
    if (this.flickityInstance && window.innerWidth <= 1100) {
      const lastIndex = this.cartProductArray.length - 4;
      this.flickityInstance.select(lastIndex);
    }
  }

  /** attach remove event to all remove buttons */
  bindRemoveEvents() {
    const removeButtons = this.querySelectorAll(".js-remove-btn:not([data-bound])");
    removeButtons.forEach((button) => {
      button.dataset.bound = "true"; // mark so we don't bind twice
      button.addEventListener("click", (event) => {
        let tenPosition = button.closest("bundle-cart-item-list")
        const key = event.currentTarget.dataset.key;
        if (!key) return;

        this.cartProductArray = this.cartProductArray.filter(item => item.key !== key);
        this.renderBundleCart();
        this.bindRemoveEvents();

        // Scroll to last item after removal
        if (this.flickityInstance && window.innerWidth <= 1100)  {
          const lastIndex = this.cartProductArray.length - 4 ;
          if (lastIndex >= 0) this.flickityInstance.select(lastIndex);
        }

        setTimeout(() => this.updateGiftMsg(), 100);
      });
    });
  }

  /** full rebuild of slots based on array order */
  renderBundleCart() {
    const cartWrapper = this.querySelector("bundle-cart");
    if (!cartWrapper) return;

    const slots = window.innerWidth <= 1100
      ? cartWrapper.querySelectorAll("bundle-cart-item-list.js-mobile-bundle-cart-item-list")
      : cartWrapper.querySelectorAll("bundle-cart-item-list");

    // clear all slots first
    slots.forEach(slot => {
      const cartImage = slot.querySelector(".js-cart-image");
      if (cartImage && !cartImage.classList.contains("js-Position-ten")) {
        cartImage.classList.add("hidden");
        cartImage.src = "";
      }
      else {
        let src = cartImage.dataset.img
        cartImage.src = src;
      }
      const cartTitle = slot.querySelector(".js-item-title");
      if (cartTitle && window.innerWidth >= 1100) {
            cartTitle.classList.add("hidden");
            cartTitle.textContent = "";
            // else { 
            //   let title = cartTitle.dataset.title;
            //   cartTitle.textContent = title;
            // }
            
      } else if (cartTitle) {
        const colorSwatches = cartTitle.querySelector(".color-swatches");
        if (colorSwatches) {
          cartTitle.classList.add("hidden");
          colorSwatches.setAttribute("style", "");
        }
      }
      const removeBtn = slot.querySelector(".js-remove-btn");
      if (removeBtn) {
        removeBtn.classList.add("hidden");
        removeBtn.dataset.key = "";
      }
    });

    // fill slots again in order of array
    this.cartProductArray.forEach((productObj, index) => {
      if (!slots[index]) return;

      const slot = slots[index];
      const cartImage = slot.querySelector(".js-cart-image");
      const cartTitle = slot.querySelector(".js-item-title");
      const removeBtn = slot.querySelector(".js-remove-btn");

      if (cartImage) {
        cartImage.classList.remove("hidden");
        cartImage.src = productObj.image;
      }

      // if (cartTitle.textContent == cartTitle.dataset.title) {
      //     cartTitle.textContent = ""
      //   }

      if (cartTitle && window.innerWidth >= 1100 && productObj.variantName != "") {
        cartTitle.classList.remove("hidden");
        cartTitle.textContent = productObj.variantName;
      } else if (cartTitle) {
        const colorSwatches = cartTitle.querySelector(".color-swatches");
        if (colorSwatches) {
          cartTitle.classList.remove("hidden");
          colorSwatches.setAttribute("style", productObj.variantStyle);
        }
      }

      if (removeBtn) {
        removeBtn.classList.remove("hidden");
        removeBtn.dataset.key = productObj.key; // use unique key
      }
    });
  }

  finalBundleAddToCart() {
    const finalAddBtn = this.querySelector(".js-main-bundle-button");
    const spinner = this.querySelector(".js-main-bundle-spinner");
    const btnText = finalAddBtn.querySelector(".btn-text");

    if (!finalAddBtn || !spinner || !btnText) return;

    finalAddBtn.addEventListener("click", async () => {
      if (this.cartProductArray.length === 0) return;

      spinner.classList.add("active");
      btnText.classList.add("hidden");
      finalAddBtn.disabled = true;

      try {
        // 1️⃣ Remove previous bundle from cart
        await this.allReadyAdd();

        // 2️⃣ Add new bundle
        const finalUniqueKey = "Bundle_" + Date.now() + "_" + Math.floor(Math.random() * 1000);
        const itemsToAdd = this.cartProductArray.map((p) => ({
          id: p.variantId,
          quantity: p.quantity,
          properties: {
            _bundle: finalUniqueKey,
            _sub__bundle: p.key,
            // "type" : "Bundle item"
          },
        }));

        const addFn = window.addItemById;
        if (typeof addFn !== "function") throw new Error("addItemById is not available on window");

        await addFn(null, null, itemsToAdd);

        // Open quick cart & reset UI
        setTimeout(() => {
          window.r$1 && window.r$1("quick-cart:open");
          this.restAllHtml();
        }, 100);

      } catch (err) {
        console.error("Error adding bundle items:", err);
      } finally {
        this.freeProductAddToCart();
        spinner.classList.remove("active");
        btnText.classList.remove("hidden");
        finalAddBtn.disabled = false;
      }
    });
  }


  async allReadyAdd() {
    const existingBundleEl = document.querySelector("[data-sub-bundle-id]");
    if (!existingBundleEl) return;

    const subBundleIds = existingBundleEl.dataset.subBundleId
      .split(",")
      .map(id => id.trim())
      .filter(id => id !== "");

    if (!subBundleIds.length) return;

    // Build object for removeItems
    const itemsToRemove = {};
    subBundleIds.forEach(key => { itemsToRemove[key] = 0; });

    if (typeof window.removeItems === "function") {
      try {
        await window.removeItems(itemsToRemove);
        console.log("Previous bundle removed from cart");
      } catch (error) {
        console.error("Error removing previous bundle:", error);
      }
    } else {
      console.warn("removeItems function not found on window");
    }
  }

  freeProductAddToCart() {
    const selectedItems = this.cartProductArray.length;
    if (selectedItems < 10) return; // nothing to do until threshold

    setTimeout(() => {
      const el = document.querySelector('main-bundle-cart');
      const freeAttr = el ? el.getAttribute("data-free-bundle-product") : null;

      if (freeAttr === "true") return;

      const freProduct = this.dataset.freeBundleProductId;
      if (!freProduct) return;

      if (selectedItems === 10) {
        const freeProductId = parseInt(freProduct, 10);
        if (isNaN(freeProductId)) return;

        const itemsToAdd = [{
          id: freeProductId,
          quantity: 1,
          properties: { _free_bundle_product: true }
        }];

        window.addItemById(null, null, itemsToAdd)
          .then(() => {
            if (el) el.setAttribute("data-free-bundle-product", "true");
          })
          .catch(err => console.error("Error adding free product to cart:", err));
      }
    }, 200);
  }

  /** reset everything after adding to Shopify cart */
  restAllHtml() {
    this.cartProductArray = [];
    this.renderBundleCart();
    this.updateGiftMsg();
  }

  updateGiftMsg() {
    let giftMsgFirst = this.querySelector(".js-first-gift");
    let giftMsgSecond = this.querySelector(".js-second-gift");
    let giftMsgThird = this.querySelector(".js-third-gift");
    const selectedItems = this.cartProductArray.length;

    if (selectedItems === 3) {
      giftMsgFirst.classList.add("selected");
    } else if (selectedItems < 3) {
      giftMsgFirst.classList.remove("selected");
    }

    if (selectedItems === 6) {
      giftMsgSecond.classList.add("selected");
    } else if (selectedItems < 6) {
      giftMsgSecond.classList.remove("selected");
    }

    if (selectedItems === 10) {
      giftMsgThird.classList.add("selected");
    } else if (selectedItems < 10) {
      giftMsgThird.classList.remove("selected");
    }
  }
}

customElements.define("bundle-container", BundleContainer);

class mainBundleCart extends HTMLElement {
  
  connectedCallback() {
    this.bundleCartItem();
    this.freProductRemove();     

  }

  bundleCartItem() {
    const removeBtn = this.querySelector(".bundle-card__remove-bundle");
    if (!removeBtn) return;

    removeBtn.addEventListener("click", async (event) => {
      event.preventDefault(); // prevent page reload
      const bundleId = this.dataset.bundleId;

      if (!bundleId) return;

      // Get sub-bundle IDs and remove blanks
      const subBundleIds = this.dataset.subBundleId.split(",").filter((id) => id.trim() !== "");

      if (!subBundleIds.length) return;

      // Build an object for removeItems function: { key: 0 }
      const itemsToRemove = {};
      subBundleIds.forEach((key) => { itemsToRemove[key] = 0;});

      // Call your global removeItems function
      if (typeof window.removeItems === "function") {
        try {
          await window.removeItems(itemsToRemove);
        } catch (error) {
          console.error("Error removing bundle items:", error);
        }
      } else {
        console.warn("removeItems function not found on window");
      }
    });
  }

  async freProductRemove() {
    const countArray = Array.from(document.querySelectorAll('[data-count]')).map(el => el.dataset.count);
    const hasTen = countArray.includes("10");
    if (hasTen == false) {
      const freeAttr = this.getAttribute("data-cart-free-bundle-product-key");
      if (!freeAttr) return;
      const itemsToRemove = {};
      itemsToRemove[freeAttr] = 0;
      await removeItems(itemsToRemove);
    }
  }

}

customElements.define("main-bundle-cart", mainBundleCart);

class removeBundleFreeProduct extends HTMLElement {
  connectedCallback() {
    this.freProductRemove();     
  }

  async freProductRemove() {
      const freeAttr = this.getAttribute("data-remove-bundle-free-product");
      if (!freeAttr) return;
      const itemsToRemove = {};
      itemsToRemove[freeAttr] = 0;
      await removeItems(itemsToRemove);
    }
  }


customElements.define("remove-bundle-free-product", removeBundleFreeProduct);




{
  document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".bundle-collection__label-item");
  const products = document.querySelectorAll(".bundle-product-item");
  const no_products = document.querySelectorAll(".no_product");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      // reset active
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      const filter = this.dataset.filter;
      let visibleCount = 0;

      // filter products
      products.forEach(prod => {
        const prodTags = prod.dataset.tags.trim().split(" ");
        if (filter === "all" || prodTags.includes(filter)) {
          prod.style.display = "";
          visibleCount++;
        } else {
          prod.style.display = "none";
        }
      });

      // toggle hidden class on no_product
      if (visibleCount === 0) {
        no_products.forEach(np => np.classList.remove("hidden"));
      } else {
        no_products.forEach(np => np.classList.add("hidden"));
      }
    });
  });

  // Trigger "All" on load (first tab)
  if (tabs.length > 0) {
    tabs[0].click();
  }
});

}